<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <TableLoading v-if="user.publicId === '0'"/>
    <div v-else class="row">
      <div class="col-xl-5">
        <div class="card overflow-hidden">
          <div class="card-body">
            <div class="bg-soft bg-primary">
              <div class="row">
                <div class="col-7">
                  <div class="text-primary p-3">
                    <h3 class="text-primary">{{ user.firstName }} {{ user.lastName }}</h3>
                  </div>
                </div>
                <div class="col-5 align-self-end">
                  <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
                </div>
              </div>
            </div>
            <div class="card-body pt-0">
              <div class="row justify-content-between">
                <div class="col-sm-4">
                  <div class="avatar-md profile-user-wid mb-4">
                    <img
                        :src="user.avatar"
                        alt
                        class="img-thumbnail rounded-circle"
                    />
                  </div>
                  <h4 class="mb-0 text-truncate text-success">Manager</h4>
                </div>
                <div class="col-4 mt-4">
                  <b-button v-if="user.activeState === false" variant="primary" size="sm" class="py-1 text-white">Activate User</b-button>
                  <b-button v-else variant="danger" size="sm" class="py-1 text-white">Deactivate User</b-button>
                </div>
                <div class="table-responsive mt-4">
                  <table class="table table-nowrap mb-0">
                    <tbody>
                    <tr>
                      <th scope="row">Name :</th>
                      <td>{{ user.firstName }} {{ user.lastName }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Phone Number :</th>
                      <td>{{ user.phoneNumber }}</td>
                    </tr>
                    <tr>
                      <th scope="row">E-mail :</th>
                      <td>{{ user.email }}</td>
                    </tr>
                    <tr v-if="user.profile">
                      <th scope="row">ID Number :</th>
                      <td>{{user.profile.idNumber}}</td>
                    </tr>
                    <tr v-if="user.profile">
                      <th scope="row">KRA Pin :</th>
                      <td>{{user.profile.kraPin}}</td>
                    </tr>
                    <tr v-if="user.profile">
                      <th scope="row">NHIF :</th>
                      <td>{{user.profile.nhif}}</td>
                    </tr>
                    <tr v-if="user.profile">
                      <th scope="row">NSSF :</th>
                      <td>{{user.profile.nssf}}</td>
                    </tr>
                    <tr v-if="user.profile">
                      <th scope="row">Physical Address :</th>
                      <td>{{user.profile.physicalAddress}}</td>
                    </tr>
                    <tr v-if="user.profile">
                      <th scope="row">P.O Box :</th>
                      <td>{{user.profile.poBox}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end card -->

        <div class="card mb-4" v-if="checkForPermission(view_single_user_permission_details_permission)">
          <div class="card-body">
            <h4 class="card-title mb-4">Permissions</h4>
            <div class="table-responsive">
              <table class="table table-nowrap align-mid table-hover mb-0">
                <tbody>
                <tr v-for="permission in user.permissionsPaginated.objects" :key="permission.id">
                  <td>
                    <h5 class="text-truncate font-size-14 mb-1">
                      <a href="javascript: void(0);" class="text-dark">
                        {{permission.name}}
                      </a>
                    </h5>
                    <p class="text-muted mb-0">{{ permission.codename }}</p>
                  </td>
                  <td style="width: 90px;vertical-align: bottom">
                    <div>
                      <ul class="list-inline mb-0 font-size-20">
                        <li class="list-inline-item">
                          <a
                              href="javascript: void(0);"
                              class="text-primary p-1"
                          >
                            <i class="bx bxs-trash"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
                </tbody>
                <b-pagination
                    v-if="user.permissionsPaginated.total > 0"
                    v-model="currentPage"
                    :total-rows="user.permissionsPaginated.total"
                    :per-page="perPage"
                    class="mt-3"
                    size="lg"
                    align="center"
                />
              </table>
            </div>
          </div>
        </div>

        <!-- end card -->
      </div>

      <div class="col-lg-6">
<!--        <div class="card mt-4">-->
<!--          <div class="card-body">-->
<!--            <h4 class="card-title mb-4">Dashboard Components</h4>-->
<!--            <div class="table-responsive">-->
<!--              <table class="table table-nowrap align-mid table-hover mb-0">-->
<!--                <tbody>-->
<!--                <tr>-->
<!--                  <td>-->
<!--                    <h5 class="text-truncate font-size-14 mb-1">-->
<!--                      <a href="javascript: void(0);" class="text-dark">-->
<!--                        Component 1-->
<!--                      </a>-->
<!--                    </h5>-->
<!--                    <p class="text-muted mb-0">Description</p>-->
<!--                  </td>-->
<!--                  <td style="width: 90px;vertical-align: bottom">-->
<!--                    <div>-->
<!--                      <ul class="list-inline mb-0 font-size-20">-->
<!--                        <li class="list-inline-item">-->
<!--                          <a-->
<!--                              href="javascript: void(0);"-->
<!--                              class="text-secondary p-1"-->
<!--                          >-->
<!--                            <i class="bx bxs-trash"></i>-->
<!--                          </a>-->
<!--                        </li>-->
<!--                      </ul>-->
<!--                    </div>-->
<!--                  </td>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                  <td>-->
<!--                    <h5 class="text-truncate font-size-14 mb-1">-->
<!--                      <a href="javascript: void(0);" class="text-dark">-->
<!--                        Component 1-->
<!--                      </a>-->
<!--                    </h5>-->
<!--                    <p class="text-muted mb-0">Description</p>-->
<!--                  </td>-->
<!--                  <td style="width: 90px;vertical-align: bottom">-->
<!--                    <div>-->
<!--                      <ul class="list-inline mb-0 font-size-20">-->
<!--                        <li class="list-inline-item">-->
<!--                          <a-->
<!--                              href="javascript: void(0);"-->
<!--                              class="text-secondary p-1"-->
<!--                          >-->
<!--                            <i class="bx bxs-trash"></i>-->
<!--                          </a>-->
<!--                        </li>-->
<!--                      </ul>-->
<!--                    </div>-->
<!--                  </td>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                  <td>-->
<!--                    <h5 class="text-truncate font-size-14 mb-1">-->
<!--                      <a href="javascript: void(0);" class="text-dark">-->
<!--                        Component 1-->
<!--                      </a>-->
<!--                    </h5>-->
<!--                    <p class="text-muted mb-0">Description</p>-->
<!--                  </td>-->
<!--                  <td style="width: 90px;vertical-align: bottom">-->
<!--                    <div>-->
<!--                      <ul class="list-inline mb-0 font-size-20">-->
<!--                        <li class="list-inline-item">-->
<!--                          <a-->
<!--                              href="javascript: void(0);"-->
<!--                              class="text-secondary p-1"-->
<!--                          >-->
<!--                            <i class="bx bxs-trash"></i>-->
<!--                          </a>-->
<!--                        </li>-->
<!--                      </ul>-->
<!--                    </div>-->
<!--                  </td>-->
<!--                </tr>-->
<!--                </tbody>-->
<!--              </table>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <div class="card mb-4">
          <div class="card-body">
            <h4 class="card-title mb-4">User Activity</h4>
            <div data-simplebar class="mt-2">
              <ul class="verti-timeline list-unstyled" v-for="(activity, index) in user.activityPaginated.objects" :key="index">
                <li class="event-list mb-4">
                  <div class="event-timeline-dot">
                    <i class="bx bx-right-arrow-circle font-size-18"></i>
                  </div>
                  <div class="d-flex">
                    <div class="me-3">
                      <h5 class="font-size-14">
                        {{formatDate(activity.activityDate)}}
                        <i
                            class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"
                        ></i>
                      </h5>
                    </div>
                    <div class="flex-grow-1">
                      <div>
                        {{ activity.activityMessage }}
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <b-pagination
                  v-if="user.activityPaginated.total > 0"
                  v-model="userActivityCurrentPage"
                  :total-rows="user.activityPaginated.total"
                  :per-page="perPage"
                  class="mt-3"
                  size="lg"
                  align="center"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import {routeItems} from "@/router/endpoints";
import {SINGLE_USER} from "@/gql";
import moment from 'moment'
import TableLoading from "@/components/TableLoading";
import {permissions} from "@/router/permissions";
export default {
  page: {
    title: "Single User",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading, PageHeader, Layout},
  name: "single-staff",
  data() {
    return {
      title: "Single User",
      items: [
        {
          text: "Users",
          href: routeItems.staff_route
        },
        {
          text: "Single User",
          active: true
        }
      ],
      view_single_user_permission_details_permission: permissions.view_single_user_permission_details_permission,
      currentPage: 1,
      userActivityCurrentPage: 1,
      perPage: 30,
      user: {
        publicId: '0',
        id: "",
        avatar: "",
        firstName: "",
        lastName: "",
        name: "",
        email: "",
        phoneNumber: "",
        isActive: "",
        isStaff: "",
        isSuperuser: "",
        createdAt: "",
        updatedAt: "",
        lastLogin: "",
        roles: {
          id: "",
          name: ""
        },
        permissionsPaginated: {
          objects: [{
            id: "",
            name: "",
            codename: ""
          }]
        },
        profile: {
          id: "",
          idNumber: "",
          kraPin: "",
          nhif: "",
          nssf: "",
          physicalAddress: "",
          poBox: "",
          dob: "",
          createdAt: "",
          updatedAt: ""
        },
        activityPaginated: {
          objects: [{
            activityMessage: "",
            activityDate: "",
          }]
        }
      }
    }
  },
  apollo: {
    user: {
      query: SINGLE_USER,
      variables(){
        return {
          id: this.$route.params.id,
          currentPage: this.currentPage,
          userActivityCurrentPage: this.userActivityCurrentPage
        }
      }
    }
  },
  methods: {
    formatDate(date){
      return moment(date).format('DD MMM YYYY')
    }
  }
}
</script>

<style scoped>

</style>
